const objeto12 = {
    titulo: `Objetos: Los métodos keys, values y entries de la clase Object`,
    problemas: [
      {
        codigo: 1,
        descripcion: `Veamos tres métodos muy utilizados cuando trabajamos con objetos. El primero es Object.keys, que nos permite obtener un array con las claves de un objeto.
<code>
const persona1 = {
  nombre: "Juan",
  apellido: "Perez",
  edad: 20,
  direccion: "Colon 1234",
  telefono: 4567234
}

const claves = Object.keys(persona1)
console.log(claves) // ["nombre", "apellido", "edad", "direccion", "telefono"]
</code>
Se almacena en la constante 'claves' un array con las claves de las propiedades de persona1
`,
        programa: `const punto1 = {
  x: 10,
  y: 5
}

console.log(Object.keys(punto1))
`,
        solucion: "[10,5]",
      }, {
        codigo: 2,
        descripcion: `El método values nos permite obtener un array con los valores de las propiedades de un objeto.
        <code>
const persona1 = {
  nombre: "Juan",
  apellido: "Perez",
  edad: 20,
  direccion: "Colon 1234",
  telefono: 4567234
}

const valores = Object.values(persona1)
console.log(valores) // ["Juan", "Perez", 20, "Colon 1234", "4567234"]
        </code>`,
        programa: `const punto1 = {
  x: 10,
  y: 5
}

const valores = Object.values(punto1)
console.log(valores[0] + valores[1])`,
        solucion: "15",
      }, {
        codigo: 3,
        descripcion: `Finalmente el método entries nos permite obtener un array con los pares clave-valor de un objeto.
        <code>
const punto1 = {
  x: 10,
  y: 5
}

const claveValor=Object.entries(punto1)
console.log(claveValor) // [["x", 10], ["y", 5]]</code>`,
        programa: `const punto1 = {
  x: 10,
  y: 5
}

suma = 0
const claveValor = Object.entries(punto1)
for (const [clave, valor] of claveValor) {
  suma += valor
}
console.log(suma)`,
        solucion: "15",
      }, {
        codigo: 4,
        descripcion: ``,
        programa: `const sueldos = {
  juan: 100,
  pedro: 300,
  maria: 500
}

let suma = 0
Object.values(sueldos).forEach(sueldo=> suma += sueldo)

console.log(suma)`,
        solucion: "900",
      }
    ]
  }
  
  export default objeto12;